import { render, staticRenderFns } from "./ConfirmTerminateDialog.vue?vue&type=template&id=ad4d2854&lang=pug&"
import script from "./ConfirmTerminateDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmTerminateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports